import React, { useState, useEffect } from 'react';
import './PhoneConsult.css';
import { supabase } from '../lib/supabase';

const PhoneConsult: React.FC = () => {
  const [kakaoOpenChatUrl, setKakaoOpenChatUrl] = useState('https://open.kakao.com/o/seS4W3fh');
  const [serviceHours, setServiceHours] = useState('평일 09:00 ~ 18:00');

  // Supabase에서 설정값 가져오기
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data, error } = await supabase
          .from('app_settings')
          .select('setting_key, setting_value')
          .in('setting_key', ['kakao_openchat_url', 'customer_service_hours'])
          .eq('is_active', true);

        if (error) {
          console.error('설정값 조회 오류:', error);
          return;
        }

        if (data) {
          data.forEach((setting) => {
            if (setting.setting_key === 'kakao_openchat_url') {
              setKakaoOpenChatUrl(setting.setting_value);
            } else if (setting.setting_key === 'customer_service_hours') {
              setServiceHours(setting.setting_value);
            }
          });
        }
      } catch (error) {
        console.error('설정값 가져오기 실패:', error);
      }
    };

    fetchSettings();
  }, []);

  const handleKakaoOpen = () => {
    // 모바일 여부 확인
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      // 모바일: 카카오톡 채널 URL은 자동으로 앱에서 열림
      window.location.href = kakaoOpenChatUrl;
    } else {
      // PC: 새 탭에서 열기
      window.open(kakaoOpenChatUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="phone-consult-container">
      <div className="phone-consult-content">
        <div className="consult-card">
          <div className="consult-icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
              <path d="M66.67 50.83c-4.1 0-8.07-.67-11.77-1.87-1.17-.4-2.47-.1-3.37.8l-5.23 6.57c-9.43-4.5-18.27-13-22.97-22.77l6.5-5.53c.9-.93 1.17-2.23.8-3.4-1.23-3.7-1.87-7.67-1.87-11.77 0-1.8-1.5-3.3-3.3-3.3h-11.5c-1.8 0-3.3.8-3.3 3.3 0 31 25.27 56 56.67 56 2.37 0 3.3-2.1 3.3-3.93v-11.5c0-1.8-1.5-3.3-3.3-3.3-.33 0-.67 0-1 0z" fill="#beae79"/>
            </svg>
          </div>

          <h1 className="consult-title">전화 상담 서비스</h1>

          <p className="consult-description">
            전화 상담이 필요하신가요?
            <br />
            실시간 톡 상담으로 편리하게
            <br />
            상담을 시작해보세요!
          </p>

          <button className="kakao-open-btn" onClick={handleKakaoOpen}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 3C6.48 3 2 6.58 2 11c0 2.78 1.83 5.23 4.58 6.73-.21 1.36-.72 4.65-.83 5.23-.14.74.27.73.56.53.2-.14 3.26-2.19 4.69-3.16.62.09 1.27.13 1.93.13 5.52 0 10-3.58 10-8s-4.48-8-10-8z" fill="#1e1e1e"/>
            </svg>
            <span>실시간 톡 상담 시작하기</span>
          </button>

          <div className="consult-info">
            <div className="info-item">
              <span className="info-icon">⏰</span>
              <span className="info-text">{serviceHours}</span>
            </div>
            <div className="info-item">
              <span className="info-icon">📞</span>
              <span className="info-text">빠른 응답 보장</span>
            </div>
            <div className="info-item">
              <span className="info-icon">💬</span>
              <span className="info-text">편리한 채팅 상담</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneConsult;
